module.exports = __webpack_public_path__ + "static/img/bot-step-8.526d33a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-8.png
// module id = OhS5
// module chunks = 11